import routes from "../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPutPayload, HttpAuthPutParams} from "../../../../core/services/common/HttpRequestBuilder";

const getListContainer = (parameters) => {
    let result = HttpAuthGet(routes.GET_LIST_CONTAINER, parameters);
    return result;
}

const getListContainerWithPagination = (parameters) => {
    let result = HttpAuthGet(routes.GET_LIST_CONTAINER_WITH_PAGINATION, parameters);
    return result;
}

const createContainer = (payload) => {
    let result = HttpAuthPost(routes.CREATE_CONTAINER, payload);
    return result;
}

const getContainerTypes = () => {
    let parameters = null;
    let result = HttpAuthGet(routes.GET_CONTAINER_TYPES, parameters);
    return result;
}

const viewContainer = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_CONTAINER, parameters);
    return result;
}

const updateContainerStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_CONTAINER_STATUS, parameters);
    return result;
}

const getContainerStatusList = () => {
    let parameters = null;
    let result = HttpAuthGet(routes.GET_CONTAINER_STATUS_LIST, parameters);
    return result;
}

const updateContainer = (payload) => {
    let result = HttpAuthPutPayload(routes.UPDATE_CONTAINER, payload);
    return result;
}

const filterContainer = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_CONTAINER, parameters);
    return result;
}


const ContainerService = {
    getListContainer: getListContainer,
    getListContainerWithPagination: getListContainerWithPagination,
    createContainer: createContainer,
    getContainerTypes: getContainerTypes,
    viewContainer: viewContainer,
    updateContainerStatus: updateContainerStatus,
    getContainerStatusList: getContainerStatusList,
    updateContainer: updateContainer,
    filterContainer: filterContainer,
}

export default ContainerService